import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { baseurl } from '../../../api';
import authenticatedAxios from '../../../authenticatedAxios';
import '../../common/CommonText.css';
import CloseButton from '../../common/CloseButton/CloseButton';

const ExchangeRatePopup = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    const popupRef = useRef(null);
    const [latestRecords, setLatestRecords] = useState([]);

    // Format date like "1-Aug 2024"
    const formatCustomDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const monthShort = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        return `${day}-${monthShort} ${year}`;
    };

    // Fetch latest exchange records
    useEffect(() => {
        const fetchLatestRecords = async () => {
            try {
                const response = await authenticatedAxios.get(`${baseurl}currency/exchange-history/`);
                const data = response.data?.data || [];
                const sortedData = data.sort((a, b) => new Date(b.date_time) - new Date(a.date_time));
                setLatestRecords(sortedData.slice(0, 5));
            } catch (error) {
                console.error("Error fetching latest exchange records:", error);
            }
        };

        if (isOpen) {
            fetchLatestRecords();
        }
    }, [isOpen]);

    // Close popup when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    // Prevent rendering if not open
    if (!isOpen) return null;

    // View More click handler
    const handleViewMoreClick = (e) => {
        e.preventDefault();
        navigate('/basic-exchange-history');
    };

    return (
        <div className="ex-overlay">
            <div className="ex-popup-content" ref={popupRef}>
                <div className="ex-exchange-rate-table">
                    <table>
                        <thead>
                            <tr>
                                <th className="exchange-rate-table-tr common-text fts-14 ftw-4 black">Date</th>
                                <th className="exchange-rate-table-tr common-text fts-14 ftw-4 black">Rate</th>
                            </tr>
                        </thead>
                        <tbody>
                            {latestRecords.map((record) => (
                                <tr key={record.id}>
                                    <td className="common-text fts-12 ftw-4 black">{formatCustomDate(record.date_time)}

                                    </td>
                                    <td className="common-text fts-12 ftw-4 black">
                                        1 {record.currency_name} = {record.dollar_exchange_rate} $
                                        {record.is_high ? (
                                        <svg className="is_high" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                                        <path d="M0.257257 6.14066L4.6795 1.71841L1.2443 1.71841L1.2443 0.638997L6.5223 0.638997V5.91699L5.44288 5.91699L5.44288 2.48179L1.02063 6.90404L0.257257 6.14066Z" fill="#148F00"/>
                                        </svg>
                                        ) : (
                                        <svg className="is_low" xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                            <path d="M1.96804 0.707936L5.09504 6.12406L5.98413 2.80591L7.02677 3.08529L5.66072 8.18344L0.562574 6.81739L0.841947 5.77476L4.1601 6.66385L1.03309 1.24773L1.96804 0.707936Z" fill="#BD3D44"/>
                                        </svg>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="view-more">
                        <a href="#" className="common-text fts-12 ftw-4 blue" onClick={handleViewMoreClick}>
                            View More
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExchangeRatePopup;